window.initExperienceProductForm = function initExperienceProductForm(
  root = document
) {
  const forms = root.querySelectorAll(
    'form[id^="product-form-"][data-type="add-to-cart-form"]'
  );

  forms.forEach((form) => {
    if (form.dataset.experienceInitialized === 'true') {
      return;
    }

    form.dataset.experienceInitialized = 'true';

    /*
     * Dawn usually renders the variant fields outside the actual
     * add-to-cart form, so search from the surrounding product area.
     */
    const productRoot =
      form.closest('product-info') ||
      form.closest('.product') ||
      root;

    const params = new URLSearchParams(window.location.search);

    const parentKey = params.get('parent_key') || '';
    const parentLineId = params.get('parent_line_id') || '';
    const parentTitle = params.get('parent_title') || '';
    const carsCountFromUrl = params.get('cars_count') || '';
    const extraQty = params.get('extra_qty') || '';
    const pricingLabel = params.get('pricing_label') || '';
    const appliesToLabel =
      params.get('applies_to_label') || '';

    /*
     * Create or find the hidden selected-car-count property.
     */
    let carCountInput = form.querySelector(
      '[name="properties[_selected_car_count]"]'
    );

    if (!carCountInput) {
      carCountInput = document.createElement('input');
      carCountInput.type = 'hidden';
      carCountInput.name =
        'properties[_selected_car_count]';
      form.appendChild(carCountInput);
    }

    /*
     * Use the URL value for linked extras. Otherwise initialise
     * to 1 until the selected product options are inspected.
     */
    carCountInput.value = carsCountFromUrl || '1';

    /*
     * Create or find the hidden premium-track property.
     */
    let premiumTrackInput = form.querySelector(
      '[name="properties[_premium_track]"]'
    );

    if (!premiumTrackInput) {
      premiumTrackInput = document.createElement('input');
      premiumTrackInput.type = 'hidden';
      premiumTrackInput.name =
        'properties[_premium_track]';
      form.appendChild(premiumTrackInput);
    }

    premiumTrackInput.value =
      premiumTrackInput.value || 'false';

    /**
     * Read one selected product option and update the hidden
     * experience properties where applicable.
     */
    function updateExperiencePropertiesFromField(field) {
  if (!field || !field.name) {
    return;
  }

  const fieldName = String(field.name)
    .trim()
    .toLowerCase();

  const fieldValue = String(field.value || '')
    .trim();

  const isCarCountField =
    (
      fieldName.includes('number of vehicles') ||
      fieldName.includes('number of cars') ||
      (
        fieldName.includes('how many') &&
        (
          fieldName.includes('car') ||
          fieldName.includes('vehicle')
        )
      )
    ) &&
    !fieldName.includes('mile');

  if (isCarCountField) {
    const countMatch = fieldValue.match(/\d+/);

    if (countMatch) {
      carCountInput.value = countMatch[0];
    }
  }

  if (
    fieldName.includes('premium circuit upgrade')
  ) {
    premiumTrackInput.value =
      fieldValue.toLowerCase() === 'yes'
        ? 'true'
        : 'false';
  }
}

    /**
     * Inspect all currently selected fields for this product.
     */
    function updateExperiencePropertiesFromSelectedFields() {
      const selectedFields =
        productRoot.querySelectorAll(
          'select, input[type="radio"]:checked'
        );

      selectedFields.forEach((field) => {
        updateExperiencePropertiesFromField(field);
      });
    }

    /*
     * Run immediately and once more after Dawn has completed
     * its product-option initialisation.
     */
    updateExperiencePropertiesFromSelectedFields();

    setTimeout(
      updateExperiencePropertiesFromSelectedFields,
      300
    );

    /*
     * Listen on the surrounding product area because the variant
     * fields may not be inside the add-to-cart form.
     */
    productRoot.addEventListener('change', (event) => {
      const field = event.target;

      if (
        !field.matches(
          'select, input[type="radio"]'
        )
      ) {
        return;
      }

      updateExperiencePropertiesFromField(field);
    });

    /*
     * Allow Dawn's normal product submission when the product
     * was not opened as a linked extra.
     */
    if (!parentKey) {
      return;
    }

    if (!parentLineId) {
      console.warn(
        'Linked extra is missing parent_line_id',
        {
          parentKey,
          parentLineId,
        }
      );

      return;
    }

    /*
     * Linked extras use the custom AJAX submission.
     */
    form.addEventListener(
      'submit',
      function handleLinkedExtraSubmit(event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        updateExperiencePropertiesFromSelectedFields();

        const formData = new FormData(form);

        /*
         * For a linked extra, prefer the car count supplied in
         * its URL. Otherwise use the selected product value.
         */
        const finalCarsCount =
          carsCountFromUrl ||
          carCountInput.value ||
          '1';

        if (extraQty) {
          formData.set('quantity', extraQty);
        }

        /*
         * Parent relationship.
         */
        formData.set(
          'properties[_parent_key]',
          parentKey
        );

        formData.set(
          'properties[_parent_line_id]',
          parentLineId
        );

        formData.set(
          'properties[For experience]',
          parentTitle
        );

        /*
         * Unique line identifier.
         */
         formData.set(
            'properties[_line_id]',
            parentLineId
          );

        /*
         * Required for participant/option display in the cart.
         */
        formData.set(
          'properties[_requires_options]',
          'true'
        );

        if (pricingLabel) {
          formData.set(
            'properties[Pricing]',
            pricingLabel
          );
        }

        /*
         * Do not store the redundant default applies-to label.
         */
        if (
          appliesToLabel &&
          appliesToLabel !==
            'Applies once to this booking'
        ) {
          formData.set(
            'properties[Applies to]',
            appliesToLabel
          );
        } else {
          formData.delete(
            'properties[Applies to]'
          );
        }

        /*
         * Preserve the selected car count.
         */
        formData.set(
          'properties[_selected_car_count]',
          finalCarsCount
        );

        formData.set(
          'properties[Cars]',
          finalCarsCount
        );

        formData.set(
          'properties[_premium_track]',
          premiumTrackInput.value || 'false'
        );

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'application/json',
          },
        })
          .then((response) => {
            if (!response.ok) {
              return response
                .text()
                .then((text) => {
                  throw new Error(
                    text ||
                      'Failed to add linked extra'
                  );
                });
            }

            return response.json();
          })
          .then(() => {
            window.location.href = '/cart';
          })
          .catch((error) => {
            console.error(
              'Could not add linked extra:',
              error
            );

            alert(
              'Could not add extra. Please try again.'
            );
          });
      },
      true
    );
  });
};

/*
 * Initialise normal product pages.
 */
if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      window.initExperienceProductForm(document);
    }
  );
} else {
  window.initExperienceProductForm(document);
}